<template>
  <v-app>
    <div>
      <v-dialog
        v-model="$store.getters.getShowLoading"
        max-width="250"
        persistent
        overlay-opacity="0.3"
      >
        <v-card height="110">
          <div class="py-3" style="text-align: center">
            <v-progress-circular
              :size="50"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div style="text-align: center">
            <p>{{ $store.getters.getLoadingText }}</p>
          </div>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar
      v-model="$store.getters.getSnackbar"
      :color="$store.getters.getSnackbarColor"
      :timeout="$store.getters.getSnackbarTimeout"
    >
      {{ $store.getters.getSnackbarText }}
    </v-snackbar>
    <Header v-if="headerType != 'noNeedHeader'"></Header>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Header from "./components/Header.vue";

export default {
  name: "App",
  components: {
    Header,
  },
  data: () => ({
    headerType: "",
  }),
  mounted() {
    this.load_all_machines_basic_info();
  },
  created() {
    this.show_close_loading("close");
    this.$store.watch((state, getters) => {
      this.headerType = getters.getHeaderType;
    });
  },
  updated() {
    if (this.$route.name != "SignInScreen") {
      if (this.$store.getters.getUserName == "") {
        this.$router.push({ name: "SignInScreen" }).catch((err) => {});
      }
    } else {
      if (this.$store.getters.getUserName != "") {
        this.$router.push({ name: "HomeScreen" }).catch((err) => {});
      }
    }
  },
};
</script>
<style scoped>
#app {
  font-family: "Poppins", sans-serif;
  background-color: #fff5f5;
}

.normal-card {
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.06) !important;
}
</style>
